import _DialogActions from "@material-ui/core/esm/DialogActions";
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
const styles = () => ({
  root: {}
});
const Footer = withStyles(styles)(props => {
  const {
    children,
    classes
  } = props;
  return /*#__PURE__*/React.createElement(_DialogActions, {
    classes: classes
  }, children);
});
export default Footer;